import * as React from 'react';
import Box from '@mui/material/Box';
import { useEffect, useState } from 'react';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import { styled } from '@mui/material/styles';
import { getApi, patchApi } from 'views/services/api';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import EditIcon from '@mui/icons-material/Edit';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useNavigate } from 'react-router';
import EditHotel from './Components/EditHotel';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import { Container, Card, CardContent, Stack, Chip, Avatar, alpha, useTheme, CircularProgress, Divider, TextField } from '@mui/material';
import {
  Hotel as HotelIcon,
  Email as EmailIcon,
  Phone as PhoneIcon,
  PhoneAndroid as PhoneAndroidIcon,
  Person as PersonIcon,
  Public as PublicIcon,
  LocationOn as LocationIcon,
  Receipt as GstIcon,
  Schedule as TimeIcon,
  Web as WebIcon,
  Map as MapIcon,
  Star as ReviewIcon,
  WhatsApp as WhatsAppIcon,
  Settings as SettingsIcon,
  Business as BusinessIcon,
  AccountBalance as TaxIcon,
  RestaurantMenu as RestaurantIcon,
  Bed as RoomIcon,
  Delete as DeleteIcon,
  Add as AddIcon,
  BookOnline as BookOnlineIcon,
  SmartToy as SmartToyIcon,
  Palette as PaletteIcon,
  Image as ImageIcon,
  RestartAlt as RestartAltIcon,
  Save as SaveIcon,
  CloudUpload as CloudUploadIcon
} from '@mui/icons-material';

// Valores por defecto del motor de reservas (coinciden con booking_stitch.html)
const BOOKING_ENGINE_DEFAULTS = {
  primaryColor: '#e77e23',
  headerColor: '#ffffff'
};

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
  ...theme.typography.body2,
  padding: theme.spacing(3),
  textAlign: 'left',
  color: theme.palette.text.secondary,
  borderRadius: 16,
  border: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
  boxShadow: theme.shadows[2]
}));

export default function HotelProfile() {
  const theme = useTheme();
  const [openEdit, setOpenEdit] = useState(false);
  const [hotelData, setHotelData] = useState({});
  const [value, setValue] = useState('1');
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const hotel = JSON.parse(localStorage.getItem('hotelData'));

  const handleOpenEditHotel = () => setOpenEdit(true);
  const handleCloseEditHotel = () => setOpenEdit(false);

  const fetchHotelData = async () => {
    try {
      const response = await getApi(`api/hotel/view/${hotel?.hotelId}`);
      setHotelData(response.data);
    } catch (error) {
      console.error('Error fetching hotel data:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchHotelData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [openEdit]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleChangeForCheckInButton = async (event) => {
    const newCheckedValue = event.target.checked;
    setHotelData((prevData) => ({ ...prevData, checkInButtonStatus: newCheckedValue }));

    try {
      const response = await patchApi(`api/hotel/editCheckInButtonStatus/${hotel?.hotelId}`, {
        status: newCheckedValue
      });
      console.log('Check-In Response:', response);
    } catch (error) {
      console.error('Error updating check-in status:', error);
    }
  };

  const handleChangeForCheckOutButton = async (event) => {
    const newCheckedValue = event.target.checked;
    setHotelData((prevData) => ({ ...prevData, checkOutButtonStatus: newCheckedValue }));

    try {
      const response = await patchApi(`api/hotel/editCheckOutButtonStatus/${hotel?.hotelId}`, {
        status: newCheckedValue
      });
      console.log('Check-Out Response:', response);
    } catch (error) {
      console.error('Error updating check-out status:', error);
    }
  };

  const handleSaveSegoIAConfig = async () => {
    try {
      const payload = {
        managerPhone: hotelData.managerPhone || '',
        managerPhone2: hotelData.managerPhone2 || '',
        aiEnabled: hotelData.aiEnabled || false
      };
      const response = await patchApi(`api/hotel/updateAIManagerConfig/${hotel?.hotelId}`, payload);
      if (response && response.status === 200) {
        // Podrías poner una alerta de éxito aquí
        console.log('Configuración de Sego IA guardada correctamente');
      }
    } catch (error) {
      console.error('Error al guardar configuración IA:', error);
    }
  };

  // 🎨 Motor de Reservas: personalización (colores + hero)
  const [bookingEngine, setBookingEngine] = useState({ primaryColor: '', headerColor: '' });
  const [heroFile, setHeroFile] = useState(null);
  const [heroPreview, setHeroPreview] = useState('');
  const [removeHero, setRemoveHero] = useState(false);
  const [savingBE, setSavingBE] = useState(false);
  const [beSaved, setBeSaved] = useState(false);

  // Sincroniza el estado local del motor con lo guardado del hotel
  useEffect(() => {
    const be = hotelData?.bookingEngine || {};
    setBookingEngine({
      primaryColor: be.primaryColor || '',
      headerColor: be.headerColor || ''
    });
    setHeroPreview(be.heroImage || '');
    setHeroFile(null);
    setRemoveHero(false);
  }, [hotelData]);

  const handleHeroFileChange = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setHeroFile(file);
    setRemoveHero(false);
    setHeroPreview(URL.createObjectURL(file));
  };

  const handleRemoveHero = () => {
    setHeroFile(null);
    setHeroPreview('');
    setRemoveHero(true);
  };

  const handleResetBookingEngine = () => {
    setBookingEngine({ primaryColor: '', headerColor: '' });
    handleRemoveHero();
  };

  const handleSaveBookingEngine = async () => {
    setSavingBE(true);
    setBeSaved(false);
    try {
      const formData = new FormData();
      formData.append('primaryColor', bookingEngine.primaryColor || '');
      formData.append('headerColor', bookingEngine.headerColor || '');
      if (heroFile) formData.append('heroImage', heroFile);
      if (removeHero) formData.append('removeHeroImage', 'true');

      const response = await patchApi(`api/hotel/updateBookingEngineConfig/${hotel?.hotelId}`, formData);
      if (response && response.status === 200) {
        setBeSaved(true);
        await fetchHotelData();
        setTimeout(() => setBeSaved(false), 3000);
      }
    } catch (error) {
      console.error('Error al guardar configuración del motor de reservas:', error);
    } finally {
      setSavingBE(false);
    }
  };

  // Función para renderizar campo de información
  const renderInfoField = (label, value, icon) => (
    <Box sx={{ mb: 3 }}>
      <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 1 }}>
        <Box
          sx={{
            width: 32,
            height: 32,
            borderRadius: 2,
            backgroundColor: alpha(theme.palette.primary.main, 0.1),
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          {icon}
        </Box>
        <Typography variant="subtitle1" fontWeight={600} color="primary">
          {label}
        </Typography>
      </Stack>
      <Typography
        variant="body1"
        sx={{
          ml: 5,
          color: value && value !== 'N/A' ? 'text.primary' : 'text.secondary',
          fontWeight: value && value !== 'N/A' ? 500 : 400
        }}
      >
        {value || 'No especificado'}
      </Typography>
    </Box>
  );

  if (loading) {
    return (
      <Container maxWidth="xl" sx={{ py: 4, display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '50vh' }}>
        <Stack alignItems="center" spacing={2}>
          <CircularProgress size={48} />
          <Typography variant="h6" color="text.secondary">
            Cargando información del hotel...
          </Typography>
        </Stack>
      </Container>
    );
  }

  return (
    <>
      <EditHotel open={openEdit} handleClose={handleCloseEditHotel} data={hotelData} />

      <Container maxWidth="xl" sx={{ py: 3 }}>
        {/* Header Section */}
        <Paper
          elevation={0}
          sx={{
            p: 3,
            mb: 3,
            background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)`,
            color: 'white',
            borderRadius: 3
          }}
        >
          <Stack direction="row" alignItems="center" justifyContent="space-between">
            <Box>
              <Typography variant="h4" fontWeight={700} gutterBottom>
                Configuración del Hotel
              </Typography>
              <Typography variant="body1" sx={{ opacity: 0.9 }}>
                Administra la información y configuración de tu hotel
              </Typography>
            </Box>
            <Box sx={{ display: { xs: 'none', md: 'block' } }}>
              <SettingsIcon sx={{ fontSize: 60, opacity: 0.3 }} />
            </Box>
          </Stack>
        </Paper>

        <Box sx={{ width: '100%' }}>
          <TabContext value={value}>
            <Card sx={{ mb: 3, borderRadius: 3 }}>
              <Box
                sx={{
                  borderBottom: 1,
                  borderColor: 'divider',
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  px: 2
                }}
              >
                <TabList
                  onChange={handleChange}
                  textColor="primary"
                  indicatorColor="primary"
                  sx={{
                    '& .MuiTab-root': {
                      textTransform: 'none',
                      fontWeight: 600,
                      fontSize: '1rem',
                      minWidth: 160
                    }
                  }}
                >
                  <Tab label="Perfil del Hotel" value="1" icon={<BusinessIcon sx={{ fontSize: 20 }} />} iconPosition="start" />
                  <Tab label="Configuración WhatsApp" value="2" icon={<WhatsAppIcon sx={{ fontSize: 20 }} />} iconPosition="start" />
                  <Tab label="Motor de Reservas" value="3" icon={<PaletteIcon sx={{ fontSize: 20 }} />} iconPosition="start" />
                  <Tab label="Asistente Sego IA" value="4" icon={<SmartToyIcon sx={{ fontSize: 20 }} />} iconPosition="start" />
                </TabList>
                <Button
                  variant="outlined"
                  startIcon={<ArrowBackIcon />}
                  onClick={() => navigate(-1)}
                  sx={{
                    borderRadius: 2,
                    textTransform: 'none',
                    fontWeight: 600
                  }}
                >
                  Volver
                </Button>
              </Box>
            </Card>

            <TabPanel value="1" sx={{ px: 0 }}>
              <Card sx={{ borderRadius: 3, overflow: 'hidden' }}>
                <Box
                  sx={{
                    background: `linear-gradient(135deg, ${alpha(theme.palette.primary.main, 0.1)} 0%, ${alpha(
                      theme.palette.primary.main,
                      0.05
                    )} 100%)`,
                    p: 3,
                    borderBottom: `1px solid ${alpha(theme.palette.divider, 0.1)}`
                  }}
                >
                  <Stack direction="row" alignItems="center" justifyContent="space-between">
                    <Stack direction="row" alignItems="center" spacing={2}>
                      <Avatar
                        sx={{
                          width: 64,
                          height: 64,
                          bgcolor: theme.palette.primary.main,
                          fontSize: '1.5rem',
                          fontWeight: 700
                        }}
                      >
                        {hotelData?.name?.charAt(0)?.toUpperCase() || 'H'}
                      </Avatar>
                      <Box>
                        <Typography variant="h5" fontWeight={700} color="primary">
                          {hotelData?.name || 'Hotel Sin Nombre'}
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                          Información completa del establecimiento
                        </Typography>
                      </Box>
                    </Stack>
                    <Button
                      startIcon={<EditIcon />}
                      variant="contained"
                      onClick={handleOpenEditHotel}
                      sx={{
                        borderRadius: 2,
                        textTransform: 'none',
                        fontWeight: 600,
                        px: 3
                      }}
                    >
                      Editar Información
                    </Button>
                  </Stack>
                </Box>

                <CardContent sx={{ p: 4 }}>
                  <Grid container spacing={4}>
                    {/* Información Básica */}
                    <Grid item xs={12} md={6}>
                      <Typography variant="h6" fontWeight={600} gutterBottom sx={{ mb: 3 }}>
                        Información Básica
                      </Typography>

                      {renderInfoField(
                        'Nombre del Hotel',
                        hotelData?.name,
                        <HotelIcon sx={{ fontSize: 18, color: theme.palette.primary.main }} />
                      )}

                      {renderInfoField(
                        'Correo Electrónico',
                        hotelData?.email,
                        <EmailIcon sx={{ fontSize: 18, color: theme.palette.info.main }} />
                      )}

                      {renderInfoField(
                        'Persona Encargada',
                        hotelData?.managerName,
                        <PersonIcon sx={{ fontSize: 18, color: theme.palette.primary.main }} />
                      )}

                      {renderInfoField(
                        'Teléfono del Hotel',
                        hotelData?.contact,
                        <PhoneIcon sx={{ fontSize: 18, color: theme.palette.success.main }} />
                      )}

                      {renderInfoField(
                        'Teléfono del Encargado',
                        hotelData?.managerPhone,
                        <PhoneAndroidIcon sx={{ fontSize: 18, color: theme.palette.success.main }} />
                      )}

                      {renderInfoField(
                        'País',
                        hotelData?.country,
                        <PublicIcon sx={{ fontSize: 18, color: theme.palette.info.main }} />
                      )}

                      {renderInfoField(
                        'Dirección',
                        hotelData?.address,
                        <LocationIcon sx={{ fontSize: 18, color: theme.palette.error.main }} />
                      )}
                    </Grid>

                    {/* Información Fiscal */}
                    <Grid item xs={12} md={6}>
                      <Typography variant="h6" fontWeight={600} gutterBottom sx={{ mb: 3 }}>
                        Información Fiscal
                      </Typography>

                      {renderInfoField(
                        'Número de Identificación Fiscal',
                        hotelData?.gstNumber,
                        <TaxIcon sx={{ fontSize: 18, color: theme.palette.warning.main }} />
                      )}

                      {renderInfoField(
                        'Impuesto en Alimentos (%)',
                        hotelData?.foodgstpercentage ? `${hotelData.foodgstpercentage}%` : null,
                        <RestaurantIcon sx={{ fontSize: 18, color: theme.palette.warning.main }} />
                      )}

                      {renderInfoField(
                        'Impuesto en Habitaciones (%)',
                        hotelData?.roomgstpercentage ? `${hotelData.roomgstpercentage}%` : null,
                        <RoomIcon sx={{ fontSize: 18, color: theme.palette.warning.main }} />
                      )}
                    </Grid>

                    {/* Horarios */}
                    <Grid item xs={12} md={6}>
                      <Typography variant="h6" fontWeight={600} gutterBottom sx={{ mb: 3 }}>
                        Horarios de Operación
                      </Typography>

                      {renderInfoField(
                        'Hora de Check-In',
                        hotelData?.checkInTime,
                        <TimeIcon sx={{ fontSize: 18, color: theme.palette.success.main }} />
                      )}

                      {renderInfoField(
                        'Hora de Check-Out',
                        hotelData?.checkOutTime,
                        <TimeIcon sx={{ fontSize: 18, color: theme.palette.error.main }} />
                      )}

                      {renderInfoField(
                        'Tiempo de Limpieza entre Estancias',
                        hotelData?.cleaningBufferMinutes != null ? `${hotelData.cleaningBufferMinutes} minutos` : '30 minutos (por defecto)',
                        <TimeIcon sx={{ fontSize: 18, color: theme.palette.warning.main }} />
                      )}
                    </Grid>

                    {/* Enlaces Web */}
                    <Grid item xs={12} md={6}>
                      <Typography variant="h6" fontWeight={600} gutterBottom sx={{ mb: 3 }}>
                        Enlaces y Servicios Web
                      </Typography>

                      {renderInfoField(
                        'Sitio Web',
                        hotelData?.websiteURL,
                        <WebIcon sx={{ fontSize: 18, color: theme.palette.primary.main }} />
                      )}

                      {/* URL del Motor de Reservas Público */}
                      {renderInfoField(
                        'Motor de Reservas (Link Público)',
                        hotelData?.slug ? `https://app.segocloud.com/reservas/${hotelData.slug}` : 'Slug no disponible',
                        <BookOnlineIcon sx={{ fontSize: 18, color: theme.palette.secondary.main }} />
                      )}

                      {renderInfoField('Google Maps', hotelData?.mapurl, <MapIcon sx={{ fontSize: 18, color: theme.palette.info.main }} />)}

                      {renderInfoField(
                        'Reseñas de Google',
                        hotelData?.googleReviewURL,
                        <ReviewIcon sx={{ fontSize: 18, color: theme.palette.warning.main }} />
                      )}
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
            </TabPanel>

            <TabPanel value="2" sx={{ px: 0 }}>
              <Card sx={{ borderRadius: 3, overflow: 'hidden' }}>
                <Box
                  sx={{
                    background: `linear-gradient(135deg, ${alpha(theme.palette.success.main, 0.1)} 0%, ${alpha(
                      theme.palette.success.main,
                      0.05
                    )} 100%)`,
                    p: 3,
                    borderBottom: `1px solid ${alpha(theme.palette.divider, 0.1)}`
                  }}
                >
                  <Stack direction="row" alignItems="center" spacing={2}>
                    <Box
                      sx={{
                        width: 56,
                        height: 56,
                        borderRadius: 3,
                        backgroundColor: alpha(theme.palette.success.main, 0.1),
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                      }}
                    >
                      <WhatsAppIcon sx={{ fontSize: 28, color: theme.palette.success.main }} />
                    </Box>
                    <Box>
                      <Typography variant="h5" fontWeight={700} color="success.main">
                        Configuración de WhatsApp
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        Controla los mensajes automáticos de check-in y check-out
                      </Typography>
                    </Box>
                  </Stack>
                </Box>

                <CardContent sx={{ p: 4 }}>
                  <Typography variant="h6" fontWeight={600} gutterBottom sx={{ mb: 4 }}>
                    Mensajes Automáticos
                  </Typography>

                  <Grid container spacing={4}>
                    <Grid item xs={12} md={6}>
                      <Card
                        sx={{
                          p: 3,
                          borderRadius: 3,
                          border: `2px solid ${hotelData.checkInButtonStatus ? theme.palette.success.main : alpha(theme.palette.divider, 0.2)
                            }`,
                          backgroundColor: hotelData.checkInButtonStatus ? alpha(theme.palette.success.main, 0.02) : 'background.paper',
                          transition: 'all 0.3s ease'
                        }}
                      >
                        <Stack direction="row" alignItems="center" justifyContent="space-between">
                          <Box>
                            <Typography variant="h6" fontWeight={600} gutterBottom>
                              Mensaje de Check-In
                            </Typography>
                            <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                              Envía mensaje automático de bienvenida cuando los huéspedes hagan check-in
                            </Typography>
                            <Chip
                              label={hotelData.checkInButtonStatus ? 'Activado' : 'Desactivado'}
                              color={hotelData.checkInButtonStatus ? 'success' : 'default'}
                              variant={hotelData.checkInButtonStatus ? 'filled' : 'outlined'}
                              size="small"
                              sx={{ fontWeight: 600 }}
                            />
                          </Box>
                          <FormGroup>
                            <FormControlLabel
                              control={
                                <Switch
                                  checked={hotelData.checkInButtonStatus}
                                  onChange={handleChangeForCheckInButton}
                                  color="success"
                                  size="medium"
                                />
                              }
                            />
                          </FormGroup>
                        </Stack>
                      </Card>
                    </Grid>

                    <Grid item xs={12} md={6}>
                      <Card
                        sx={{
                          p: 3,
                          borderRadius: 3,
                          border: `2px solid ${hotelData.checkOutButtonStatus ? theme.palette.warning.main : alpha(theme.palette.divider, 0.2)
                            }`,
                          backgroundColor: hotelData.checkOutButtonStatus ? alpha(theme.palette.warning.main, 0.02) : 'background.paper',
                          transition: 'all 0.3s ease'
                        }}
                      >
                        <Stack direction="row" alignItems="center" justifyContent="space-between">
                          <Box>
                            <Typography variant="h6" fontWeight={600} gutterBottom>
                              Mensaje de Check-Out
                            </Typography>
                            <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                              Envía mensaje de despedida y solicitud de reseña al hacer check-out
                            </Typography>
                            <Chip
                              label={hotelData.checkOutButtonStatus ? 'Activado' : 'Desactivado'}
                              color={hotelData.checkOutButtonStatus ? 'warning' : 'default'}
                              variant={hotelData.checkOutButtonStatus ? 'filled' : 'outlined'}
                              size="small"
                              sx={{ fontWeight: 600 }}
                            />
                          </Box>
                          <FormGroup>
                            <FormControlLabel
                              control={
                                <Switch
                                  checked={hotelData.checkOutButtonStatus}
                                  onChange={handleChangeForCheckOutButton}
                                  color="warning"
                                  size="medium"
                                />
                              }
                            />
                          </FormGroup>
                        </Stack>
                      </Card>
                    </Grid>
                  </Grid>

                  <Box sx={{ mt: 4, p: 3, backgroundColor: alpha(theme.palette.info.main, 0.05), borderRadius: 2 }}>
                    <Typography variant="body2" color="text.secondary">
                      <strong>Nota:</strong> Los mensajes automáticos de WhatsApp requieren configuración previa de la API. Contacta al
                      soporte técnico si necesitas ayuda con la configuración inicial.
                    </Typography>
                  </Box>
                </CardContent>
              </Card>
            </TabPanel>

            <TabPanel value="3" sx={{ px: 0 }}>
              <Card sx={{ borderRadius: 3, overflow: 'hidden' }}>
                <Box
                  sx={{
                    background: `linear-gradient(135deg, ${alpha(theme.palette.primary.main, 0.1)} 0%, ${alpha(
                      theme.palette.primary.main,
                      0.05
                    )} 100%)`,
                    p: 3,
                    borderBottom: `1px solid ${alpha(theme.palette.divider, 0.1)}`
                  }}
                >
                  <Stack direction="row" alignItems="center" spacing={2}>
                    <Box
                      sx={{
                        width: 56,
                        height: 56,
                        borderRadius: 3,
                        backgroundColor: alpha(theme.palette.primary.main, 0.1),
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                      }}
                    >
                      <PaletteIcon sx={{ fontSize: 28, color: theme.palette.primary.main }} />
                    </Box>
                    <Box>
                      <Typography variant="h5" fontWeight={700} color="primary">
                        Motor de Reservas
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        Personaliza los colores y la imagen de tu página pública de reservas
                      </Typography>
                    </Box>
                  </Stack>
                </Box>

                <CardContent sx={{ p: 4 }}>
                  <Box sx={{ mb: 4, p: 2.5, backgroundColor: alpha(theme.palette.info.main, 0.05), borderRadius: 2 }}>
                    <Typography variant="body2" color="text.secondary">
                      Si dejas un campo vacío, se usará el <strong>diseño preestablecido</strong>. Tu logotipo (configurado
                      en el perfil del hotel) también aparece automáticamente en el motor.
                    </Typography>
                    {hotelData?.slug && (
                      <Typography variant="body2" sx={{ mt: 1 }}>
                        <BookOnlineIcon sx={{ fontSize: 16, verticalAlign: 'text-bottom', mr: 0.5, color: theme.palette.secondary.main }} />
                        <a
                          href={`https://app.segocloud.com/reservas/${hotelData.slug}`}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{ color: theme.palette.primary.main, fontWeight: 600 }}
                        >
                          Ver mi motor de reservas
                        </a>
                      </Typography>
                    )}
                  </Box>

                  <Grid container spacing={4}>
                    {/* Color de botones */}
                    <Grid item xs={12} md={6}>
                      <Typography variant="subtitle1" fontWeight={600} gutterBottom>
                        Color de los botones
                      </Typography>
                      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                        Aplica a «Reserva Ahora», «Verifica Disponibilidad» y «Book Now».
                      </Typography>
                      <Stack direction="row" alignItems="center" spacing={2}>
                        <Box
                          component="input"
                          type="color"
                          value={bookingEngine.primaryColor || BOOKING_ENGINE_DEFAULTS.primaryColor}
                          onChange={(e) => setBookingEngine({ ...bookingEngine, primaryColor: e.target.value })}
                          sx={{
                            width: 56,
                            height: 56,
                            p: 0,
                            border: `1px solid ${alpha(theme.palette.divider, 0.4)}`,
                            borderRadius: 2,
                            cursor: 'pointer',
                            backgroundColor: 'transparent'
                          }}
                        />
                        <TextField
                          size="small"
                          label="Código HEX"
                          placeholder={BOOKING_ENGINE_DEFAULTS.primaryColor}
                          value={bookingEngine.primaryColor}
                          onChange={(e) => setBookingEngine({ ...bookingEngine, primaryColor: e.target.value })}
                          sx={{ width: 160 }}
                        />
                        {bookingEngine.primaryColor && (
                          <Button size="small" onClick={() => setBookingEngine({ ...bookingEngine, primaryColor: '' })}>
                            Predeterminado
                          </Button>
                        )}
                      </Stack>
                    </Grid>

                    {/* Color del header */}
                    <Grid item xs={12} md={6}>
                      <Typography variant="subtitle1" fontWeight={600} gutterBottom>
                        Color del header
                      </Typography>
                      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                        Fondo de la barra superior de la página de reservas.
                      </Typography>
                      <Stack direction="row" alignItems="center" spacing={2}>
                        <Box
                          component="input"
                          type="color"
                          value={bookingEngine.headerColor || BOOKING_ENGINE_DEFAULTS.headerColor}
                          onChange={(e) => setBookingEngine({ ...bookingEngine, headerColor: e.target.value })}
                          sx={{
                            width: 56,
                            height: 56,
                            p: 0,
                            border: `1px solid ${alpha(theme.palette.divider, 0.4)}`,
                            borderRadius: 2,
                            cursor: 'pointer',
                            backgroundColor: 'transparent'
                          }}
                        />
                        <TextField
                          size="small"
                          label="Código HEX"
                          placeholder={BOOKING_ENGINE_DEFAULTS.headerColor}
                          value={bookingEngine.headerColor}
                          onChange={(e) => setBookingEngine({ ...bookingEngine, headerColor: e.target.value })}
                          sx={{ width: 160 }}
                        />
                        {bookingEngine.headerColor && (
                          <Button size="small" onClick={() => setBookingEngine({ ...bookingEngine, headerColor: '' })}>
                            Predeterminado
                          </Button>
                        )}
                      </Stack>
                    </Grid>

                    {/* Foto del hero */}
                    <Grid item xs={12}>
                      <Divider sx={{ my: 1 }} />
                      <Typography variant="subtitle1" fontWeight={600} gutterBottom sx={{ mt: 2 }}>
                        Fotografía principal (Hero)
                      </Typography>
                      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                        Imagen de fondo de la sección de bienvenida. Para que se vea nítida y sin recortes, usa estas medidas:
                      </Typography>

                      <Stack direction="row" flexWrap="wrap" gap={1} sx={{ mb: 3 }}>
                        <Chip
                          icon={<ImageIcon sx={{ fontSize: 16 }} />}
                          label="Tamaño recomendado: 1920 × 1080 px"
                          color="primary"
                          variant="outlined"
                          sx={{ fontWeight: 600 }}
                        />
                        <Chip label="Proporción 16:9 (horizontal)" variant="outlined" />
                        <Chip label="Mínimo 1600 × 900 px" variant="outlined" />
                        <Chip label="Formato JPG o PNG" variant="outlined" />
                        <Chip label="Peso máximo 2 MB" variant="outlined" />
                      </Stack>

                      <Stack direction={{ xs: 'column', sm: 'row' }} spacing={3} alignItems={{ xs: 'stretch', sm: 'center' }}>
                        <Box
                          sx={{
                            width: { xs: '100%', sm: 280 },
                            height: 160,
                            borderRadius: 2,
                            border: `1px dashed ${alpha(theme.palette.divider, 0.5)}`,
                            backgroundColor: alpha(theme.palette.primary.main, 0.03),
                            backgroundImage: heroPreview ? `url(${heroPreview})` : 'none',
                            backgroundSize: 'cover',
                            backgroundPosition: 'center',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            color: 'text.secondary'
                          }}
                        >
                          {!heroPreview && (
                            <Stack alignItems="center" spacing={1}>
                              <ImageIcon sx={{ fontSize: 32, opacity: 0.5 }} />
                              <Typography variant="caption">Imagen preestablecida</Typography>
                            </Stack>
                          )}
                        </Box>

                        <Stack spacing={1.5}>
                          <Button
                            component="label"
                            variant="outlined"
                            startIcon={<CloudUploadIcon />}
                            sx={{ borderRadius: 2, textTransform: 'none', fontWeight: 600 }}
                          >
                            Subir imagen
                            <input hidden type="file" accept="image/png,image/jpeg,image/jpg" onChange={handleHeroFileChange} />
                          </Button>
                          {heroPreview && (
                            <Button
                              color="error"
                              startIcon={<DeleteIcon />}
                              onClick={handleRemoveHero}
                              sx={{ textTransform: 'none' }}
                            >
                              Quitar imagen
                            </Button>
                          )}
                        </Stack>
                      </Stack>
                    </Grid>
                  </Grid>

                  <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mt: 4 }}>
                    <Button
                      startIcon={<RestartAltIcon />}
                      onClick={handleResetBookingEngine}
                      sx={{ textTransform: 'none', fontWeight: 600 }}
                    >
                      Restablecer todo
                    </Button>
                    <Stack direction="row" alignItems="center" spacing={2}>
                      {beSaved && (
                        <Chip label="Guardado" color="success" size="small" sx={{ fontWeight: 600 }} />
                      )}
                      <Button
                        variant="contained"
                        onClick={handleSaveBookingEngine}
                        disabled={savingBE}
                        startIcon={savingBE ? <CircularProgress size={18} color="inherit" /> : <SaveIcon />}
                        sx={{ py: 1.5, px: 4, borderRadius: 2, fontWeight: 600, textTransform: 'none' }}
                      >
                        {savingBE ? 'Guardando...' : 'Guardar configuración'}
                      </Button>
                    </Stack>
                  </Stack>
                </CardContent>
              </Card>
            </TabPanel>

            <TabPanel value="4" sx={{ px: 0 }}>
              <Card sx={{ borderRadius: 3, overflow: 'hidden' }}>
                <Box
                  sx={{
                    background: `linear-gradient(135deg, ${alpha(theme.palette.secondary.main, 0.1)} 0%, ${alpha(
                      theme.palette.secondary.main,
                      0.05
                    )} 100%)`,
                    p: 3,
                    borderBottom: `1px solid ${alpha(theme.palette.divider, 0.1)}`
                  }}
                >
                  <Stack direction="row" alignItems="center" spacing={2}>
                    <Box
                      sx={{
                        width: 56,
                        height: 56,
                        borderRadius: 3,
                        backgroundColor: alpha(theme.palette.secondary.main, 0.1),
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                      }}
                    >
                      <SmartToyIcon sx={{ fontSize: 28, color: theme.palette.secondary.main }} />
                    </Box>
                    <Box>
                      <Typography variant="h5" fontWeight={700} color="secondary.main">
                        Asistente Inteligente (Sego IA)
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        Configura el acceso al asistente IA vía WhatsApp para el gerente del hotel
                      </Typography>
                    </Box>
                  </Stack>
                </Box>

                <CardContent sx={{ p: 4 }}>
                  <Typography variant="h6" fontWeight={600} gutterBottom sx={{ mb: 4 }}>
                    Credenciales del Asistente
                  </Typography>

                  <Grid container spacing={4}>
                    <Grid item xs={12} md={6}>
                      <TextField
                        fullWidth
                        label="Teléfono del Gerente 1 (Ej: +58414123..."
                        variant="outlined"
                        value={hotelData.managerPhone || ''}
                        onChange={(e) => setHotelData({ ...hotelData, managerPhone: e.target.value })}
                        helperText="Principal autorizado para Sego IA"
                      />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <TextField
                        fullWidth
                        label="Teléfono del Gerente 2 (Opcional)"
                        variant="outlined"
                        value={hotelData.managerPhone2 || ''}
                        onChange={(e) => setHotelData({ ...hotelData, managerPhone2: e.target.value })}
                        helperText="Secundario autorizado para Sego IA"
                      />
                    </Grid>

                    <Grid item xs={12}>
                      <Card
                        sx={{
                          p: 3,
                          borderRadius: 3,
                          border: `2px solid ${hotelData.aiEnabled ? theme.palette.secondary.main : alpha(theme.palette.divider, 0.2)}`,
                          backgroundColor: hotelData.aiEnabled ? alpha(theme.palette.secondary.main, 0.02) : 'background.paper',
                          transition: 'all 0.3s ease'
                        }}
                      >
                        <Stack direction="row" alignItems="center" justifyContent="space-between">
                          <Box>
                            <Typography variant="h6" fontWeight={600} gutterBottom>
                              Habilitar Sego IA
                            </Typography>
                            <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                              Activa o desactiva las respuestas automáticas del asistente inteligente
                            </Typography>
                            <Chip
                              label={hotelData.aiEnabled ? 'Activado' : 'Desactivado'}
                              color={hotelData.aiEnabled ? 'secondary' : 'default'}
                              variant={hotelData.aiEnabled ? 'filled' : 'outlined'}
                              size="small"
                              sx={{ fontWeight: 600 }}
                            />
                          </Box>
                          <FormGroup>
                            <FormControlLabel
                              control={
                                <Switch
                                  checked={hotelData.aiEnabled || false}
                                  onChange={(e) => setHotelData({ ...hotelData, aiEnabled: e.target.checked })}
                                  color="secondary"
                                  size="medium"
                                />
                              }
                            />
                          </FormGroup>
                        </Stack>
                      </Card>
                    </Grid>

                    <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
                      <Button
                        variant="contained"
                        color="secondary"
                        onClick={handleSaveSegoIAConfig}
                        startIcon={<SmartToyIcon />}
                        sx={{ py: 1.5, px: 4, borderRadius: 2, fontWeight: 600 }}
                      >
                        Guardar Configuración IA
                      </Button>
                    </Grid>

                  </Grid>

                  <Box sx={{ mt: 4, p: 3, backgroundColor: alpha(theme.palette.info.main, 0.05), borderRadius: 2 }}>
                    <Typography variant="body2" color="text.secondary">
                      <strong>Nota:</strong> Sego IA interceptará todos los mensajes que reciba el webhook principal del sistema únicamente cuando provengan del teléfono aquí configurado. Otras acciones como Pre-Reservas seguirán operando para sus clientes.
                    </Typography>
                  </Box>
                </CardContent>
              </Card>
            </TabPanel>
          </TabContext>
        </Box>
      </Container>
    </>
  );
}
